<script setup lang="ts">
import { AppLink } from '#components'

defineProps<{
  title?: string
  links: any[]
}>()

// const quicklinks = ref<HTMLElement | null>(null)

// const { x, arrivedState } = useScroll(quicklinks)

// const showNext = () => {
//   x.value = x.value + quicklinks.value?.clientWidth
// }

// const showPrev = () => {
//   x.value = x.value - quicklinks.value?.clientWidth
// }
</script>

<template>
  <div
    class="quick-links"
  >
    <!-- <slot /> -->

    <!-- <h3
      v-if="title"
      class="quick-links__heading"
    >
      {{ title }}
    </h3> -->

    <div class="quick-links__container">
      <!-- <button
        type="button"
        class="quick-links__prev"
        @click="showPrev"
      >
        <Icon
          name="icon:arrow"
          class="icon icon--arrow icon--arrow-left"
        />
      </button> -->

      <ul
        ref="quicklinks"
        class="quick-links__list"
      >
        <li
          v-for="(link, index) in links"
          :key="index"
          class="quick-links__item"
        >
          <AppLink
            v-if="link?.Link"
            class="quick-links__button"
            :to="link.Link"
          >
            <span>{{ link.Name }}</span>
          </AppLink>
        </li>
      </ul>

      <!-- <button
        type="button"
        class="quick-links__next"
        @click="showNext"
      >
        <Icon
          name="icon:arrow"
          class="icon icon--arrow icon--arrow-right"
        />
      </button> -->
    </div>
  </div>
</template>

<style src="~layers/app/components/Catalog/QuickLinks.css" />
